import { useAdmins as useAdminsApi } from 'api/requests';
import { useQueryListData } from 'hooks';
import { generatePath, ROUTES } from 'libs/navigation';
import { TableSetRowHref } from 'libs/ui';

import { AdminsListItem } from '../types';

const LIMIT = 50;

export const useAdmins = () => {
  const {
    list: admins,
    rowCount,
    loading,
    setFilter,
    sort,
    page,
    filter,
    error,
    onPaginationChange,
    onSortChange,
  } = useQueryListData(useAdminsApi, {
    limit: LIMIT,
    filterParams: ['search'],
    filterParsers: {
      search: (value) => value,
    },
  });

  const setRowHref: TableSetRowHref<AdminsListItem> = (admin) =>
    generatePath(ROUTES.administration.admins.admin.fullPath, {
      adminId: admin.id,
    });

  return {
    admins,
    loading,
    sort,
    page,
    rowCount,
    limit: LIMIT,
    filter,
    error,
    setFilter,
    setRowHref,
    onSortChange,
    onPaginationChange,
  };
};
